<template>
  <v-container class="px-0">
    <v-expansion-panels v-model="panels" accordion>
      <v-expansion-panel>
        <v-expansion-panel-header
          class="font-weight-bold pl-4 text-decoration-underline"
          style="font-weight: 300; font-size: 15px"
        >
          Mapeamentos
        </v-expansion-panel-header>
        <v-expansion-panel-content class="validacoes-sdi-map-content">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="subtitle-1">Arquivo</th>
                  <th class="subtitle-1">Documentos Referentes</th>
                  <th class="subtitle-1">Ações</th>
                </tr>
                <tr v-for="(value, key) in uploadedFiles" :key="key">
                  <td class="px-4" style="width: 55% !important">
                    <span class="d-inline-flex">
                      {{ value.nome }}
                      <v-icon size="9" class="mb-3 pl-1" color="error">mdi-asterisk</v-icon>
                    </span>
                  </td>
                  <td class="px-4" style="width: 45% !important">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <v-select
                        v-model="parametros[value.arquivo_id]"
                        item-text="nome"
                        item-value="tabela"
                        dense
                        :items="tabelas"
                        :loading="loading"
                        :disabled="loading"
                        :hide-details="errors.length ? false : true"
                        :error-messages="errors"
                      />
                    </validation-provider>
                  </td>
                  <td class="px-4" style="width: 5% !important">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          min-width="0"
                          class="px-1"
                          fab
                          icon
                          x-small
                          v-bind="attrs"
                          v-on="on"
                          @click="
                            ($emit('mapeamento:apagar-arquivo', { arquivo_id: value.arquivo_id }),
                            apagarParametroByArquivoId(value.arquivo_id))
                          "
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique aqui para excluir o arquivo {{ value.nome }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
  import ValidacoesSdiService from '@/services/ValidacoesSdiService';

  export default {
    props: {
      uploadedFiles: {
        type: Array,
        default: () => []
      }
    },

    emits: ['mapeamento:apagar-arquivo'],

    data: () => ({
      panels: 0,
      search: '',
      loading: false,
      headers: [
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Documentos Referentes',
          value: 'documentos_referentes'
        },
        {
          text: 'Ações',
          value: 'acoes'
        }
      ],
      parametros: {},
      tabelas: []
    }),

    created() {
      this.getTabelasModelo1();
    },

    methods: {
      getTabelasModelo1() {
        this.loading = true;

        ValidacoesSdiService.getTabelasModelo1()
          .then((resp) => (this.tabelas = resp.data.data))
          .catch((err) => {
            this.$toast.error('Erro ao recuperar a relação das tabelas do modelo 1.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => (this.loading = false));
      },

      exportData() {
        let params = {};

        let count = 1;
        for (var [key, value] of Object.entries(this.parametros)) {
          const { extensao, nome } = this.getAllInfoByArquivoId(key);

          params[count] = { arquivo_uploaded: `${key}.${extensao}`, arquivo_original: nome, tabela: value };
          count++;
        }
        return params;
      },

      getAllInfoByArquivoId(id) {
        let info = '';

        this.uploadedFiles.forEach((file) => {
          if (file.arquivo_id == id) info = file;
        });

        return info;
      },

      apagarParametroByArquivoId(id) {
        delete this.parametros[id];
      }
    }
  };
</script>

<style>
  .validacoes-sdi-map-content .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
</style>